import { Box, Button } from '@mui/material'
import React, { useEffect, useState } from 'react'
import DropDownOA from '../../../common/dropDownOA'
import { Item } from '../../../common/snippets'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import Datepicker from '../../../common/datePicker'
import { focusElemnt, navigation3, removeDuplicatesFromArray } from '../../../common/helper'
import { SplitButton } from '../../../common/SplitButton'
import BranchWiseBalanceTable from './BranchWiseBalanceTable'
import { branchwiseColumnDefs, branchwiseDummyData, getBranchWiseBalanceReportData } from './constants'
import moment from 'moment'
import { useSearchParams } from 'react-router-dom'
import useToken from '../../../helpers/useTokens'
import { useSetAtom } from 'jotai'
import { alertAtom, globalLoaderAtom } from '../../../common/jotaiState/globalStateAtoms'
import { downloadPDF } from '../../Reports/analysisReport/pdfAutotable'
import { GetRequest, GetRequestCachedV3, PostRequestCachedV3 } from '../../../common/api'
import { urls } from '../../../common/constants'
import { getDecryptedReportParams } from '../../../common/loginDecode'
const BranchWiseBalance = (props) => {
  const { selectedTab } = props
  const [filters, setFilters] = useState({ fromDate: moment(new Date()), toDate: moment(new Date()), city: '', branch: '' })
  const [cityList, setCityList] = useState([])
  const [branchList, setBranchList] = useState({ originalBranchList: [], filteredBranchList: [] })

  const setAlert = useSetAtom(alertAtom)
  const setLoader = useSetAtom(globalLoaderAtom)
  const reportName = 'Branchwise Balance Summary'
  const [urlSearchParams] = useSearchParams()
  const searchParams = getDecryptedReportParams(urlSearchParams)
  let { loginData = {} } = useToken()
  let isFromUrl = false
  if (!loginData) {
    loginData = {}
    loginData.intCompanyID = +searchParams.get('C') || 0
    loginData.intBranchCityID = +searchParams.get('CT') || 0
    loginData.intBranchID = +searchParams.get('B') || 0
    loginData.intUserID = +searchParams.get('U') || 0
    loginData.strCompanyName = searchParams.get('CN') || ''
    loginData.strCityName = searchParams.get('CTN') || 0
    loginData.strBranchName = searchParams.get('BN') || ''
    loginData.strUserName = searchParams.get('UN') || ''
    isFromUrl = true
  }

  const criteriaHeaders = [
    { field: 'fromDate', header: 'From Date', textAlign: 'left' },
    { field: 'toDate', header: 'To Date', textAlign: 'left' },
    { field: 'city', header: 'Select City', textAlign: 'left' },
    { field: 'branch', header: 'Select Branch', textAlign: 'left' },
  ]
  const criteriaData = {
    fromDate: moment(filters?.fromDate).format('DD-MM-YYYY'),
    toDate: moment(filters?.toDate).format('DD-MM-YYYY'),
    city: filters?.city?.CityName,
    branch: filters?.branch?.BranchName,
    dataType: 'entry',
  }
  useEffect(() => {
    if (loginData?.intCompanyID) {
      let cityBody = {
        intUserID: loginData?.intUserID,
        intCompanyID: loginData?.intCompanyID,
        intStateID: 0,
      }
      setLoader(true)
      GetRequestCachedV3(urls.getCityList, cityBody, true, 24 * 60 * 60 * 1000)
        .then((res) => {
          setLoader(false)
          if (res.status === 'Success') {
            let newData = removeDuplicatesFromArray(res.Data.Table, 'CityID')
            const cityNames = newData.map(city => ({ CityID: city.CityID, CityName: city.CityName }));
            setCityList(cityNames)
            const loginCity = cityNames?.filter((val) => val.CityID === loginData?.intBranchCityID)
            setFilters((prev) => ({ ...prev, city: loginCity?.[0] }))
          } else {
            setCityList([])
          }
        })


      const branchBody = {
        intUserID: 0,
        intCompanyID: loginData?.intCompanyID,
        intBranchID: 0,
        strBranchName: '',
        strBranchCode: '',
        intStateID: 0,
        intCityID: 0,
        intIsActive: 1,
      }
      setLoader(true)
      PostRequestCachedV3(urls.getBranchConfigOrEwbillinfo, branchBody, true, 24 * 60 * 60)
        .then((res) => {
          setLoader(false)
          if (res.status === 'Success') {
            let branchData = removeDuplicatesFromArray(res?.Data?.Table, 'BranchID')
            const branchNames = branchData.map(item => ({ BranchID: item.BranchID, BranchName: item.BranchName, CityID: item.CityID }));
            setBranchList({ originalBranchList: branchNames, filteredBranchList: branchNames });
            const loginBranch = branchNames?.filter((val) => val.BranchID === loginData?.intBranchID)
            setFilters((prev) => ({ ...prev, branch: loginBranch?.[0] }))
          }else{
             setBranchList({ originalBranchList: [], filteredBranchList: [] });
          }
        })
    }

  }, [loginData?.intCompanyID])
  useEffect(() => {
    if (branchList?.originalBranchList?.length > 0) {
      let newData = branchList?.originalBranchList?.filter((val) => val.CityID === filters?.city?.CityID)
      const branchNames = newData.map(item => ({ BranchID: item.BranchID, BranchName: item.BranchName, CityID: item.CityID }));
      setBranchList((prev) => ({ ...prev, filteredBranchList: branchNames }))
      setFilters((prev) => ({ ...prev, branch: branchNames?.[0] }))
    }
  }, [filters?.city])

  const handleClick1 = async (isPdf = false) => {
    try {
      const body = {
        CompanyID: loginData?.intCompanyID,
        CityID: filters?.city?.CityID,
        BranchID: filters?.branch?.BranchID,
        FromDate: moment(new Date(filters?.fromDate)).format('YYYY-MM-DD'),
        ToDate: moment(new Date(filters?.toDate)).format('YYYY-MM-DD')
      }

      setLoader(true)

      const reportData = await getBranchWiseBalanceReportData(body, setAlert)

      setLoader(false)

      if (reportData.length === 0) {
        setAlert({ show: true, msg: 'No Data Found', nextId: '' })
        return
      }
      const headers = branchwiseColumnDefs?.map((val) => ({
        ...val,
        field: val.dataKey,
        align: val.align || (val.xlCol?.dataType === 'quantity' ? 'right' : 'left'),
        exportHead: val.header,
        weight:val.weight??40,
        dataType:'header'
      }))
      if (isPdf) {
        downloadPDF({
          reportName,
          criteriaHeaders,
          criteriaData: [criteriaData],
          tableData: reportData,
          visibleColumns: headers,
          loginData,
          hideHeader: false
        })
        return
      }

      const rid = Date.now().toString()
      window.generatedReports = window.generatedReports || {}
      window.generatedReports[rid] = {
        id: 'branch_wise_balance_report',
        reportName,
        reportData,
        criteriaHeaders,
        criteriaData,
        saveMeta: {
          CompanyID: loginData?.intCompanyID,
          CityID: filters?.city?.CityID || 0,
          BranchID: filters?.branch?.BranchID || 0,
          FromDate: moment(new Date(filters?.fromDate)).format('YYYY-MM-DD') || '',
          ToDate: moment(new Date(filters?.toDate)).format('YYYY-MM-DD') || ''
        },
        loginData,
      }

      window.open(`/view-reportV2?rid=${rid}`, "_blank")

    } catch (err) {
      setLoader(false)
      setAlert({ show: true, msg: err.message, nextId: '' })
    }
  }

  return (
    <>
      <Box sx={sx.reportFlex}>
        {isFromUrl ? <></> : <>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={'selectCompnay'}
              label={'Select Company'}
              defaultvalue={loginData?.strCompanyName || ''}
              disabled={true}
              // onSelect={(val) => { setSelCompany(val);}}
              width="250px"
            />{' '}
          </Item>
          <Item sx={sx.itemsx} className="disabled-wrapper">
            <Button
              variant="contained"
              disabled={true}
              style={{ ...sx.fullHeight, ...sx.novp }}
              id={'goButton'}
              className="btn btn-primary"
            >
              GO
            </Button>
          </Item></>}
        <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx} className="input--container bookingDatePicker">
          <Datepicker
            name={'from_collection_date'}
            value={filters?.fromDate}
            label={'From Date'}
            id={'fromDate'}
            dateChange={(date) => {
              setFilters((prev) => ({
                ...prev,
                fromDate: date
              }))
              focusElemnt('toDate')
            }}
            width="100%"
          />
        </Item>
        <Item sx={isFromUrl ? { ...sx.itemsxGrow, width: '60%' } : sx.itemsx} className="input--container bookingDatePicker">
          <Datepicker
            label={'To Date'}
            value={filters?.toDate}
            id={'toDate'}
            dateChange={(date) => {
              setFilters((prev) => ({
                ...prev,
                toDate: date
              }))
              focusElemnt('destCity')
            }}
            width="100%"
          />
        </Item>
        <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
          <DropDownOA
            label="Select City"
            id="selectCity"
            nextId={''}
            prevId={''}
            defaultvalue={filters?.city?.CityName || ''}
            data={cityList || []}
            dataKey={`CityName`}
            idKey={`CityID`}
            onSelect={(val) => {
              setFilters((prev) => ({
                ...prev,
                city: val
              }))
            }}
            disabled={false}
            isObjArr={true}
            searchPlaceholder={`Search By City Name`}
            width="100%"
          />
        </Item>
        <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
          <DropDownOA
            label="Select Branch"
            id="selectBranch"
            nextId={''}
            prevId={''}
            data={branchList?.filteredBranchList || []}
            defaultvalue={filters?.branch?.BranchName || ""}
            dataKey={`BranchName`}
            idKey={`BranchID`}
            onSelect={(val) => {
              setFilters((prev) => ({
                ...prev,
                branch: val
              }))
            }}
            disabled={false}
            isObjArr={true}
            searchPlaceholder={`Search By Branch Name`}
            width="100%"
            listWidth={'250px'}
          />
        </Item>
        {isFromUrl ?
          <Button variant="contained" sx={{ width: '100%', height: '40px' }} className="btn btn-primary" onClick={() => handleClick1(true)} >
            DOWNLOAD PDF
          </Button> :
          <Item
            sx={sx.itemsx}
            onKeyDown={(e) => navigation3(e, 'refreshBtn', 'status', () => handleClick1(false))}
          >
            <SplitButton
              hideToggle={true}
              options={['GENERATE']}
              id1={'splitButton'}
              onClick1={() => handleClick1(false)}
            />
          </Item>
        }
      </Box>
    </>
  )
}

export default BranchWiseBalance
